<script>
    import RecycleModal from './RecycleModal.vue'
    import FailModal from './FailModal.vue'
    import moment from 'moment'

    export default {
        components: {
            RecycleModal,
            FailModal
        },
        props: {
            jobApplication: {
                type: Object,
                required: true
            },
            csrfToken: {
                type: String,
                required: true
            },
            logs: {
                type: Object,
                required: false
            },
        },
        data() {
            return {
                average: 0,
                fail_reason: '',
                passBtnDisabled: false,
                skill_assessment_status: this.jobApplication.skill_assessment_status,
            }
        },
        methods: {
            toggleModal(ref) {
                this.$refs[ref].toggleModal()
            },
            sliceString(value) {
                return value.substring(value.lastIndexOf("/")+1)
            },
            fail(fail_reason) {
                this.fail_reason = fail_reason
                this.$nextTick(() => {
                    this.$refs.failedButton.click();
                });
            },
            disablePassBtn() {
                this.passBtnDisabled = true;
                this.skill_assessment_status = 'passed';

                let form = this.$refs['form'];
                setTimeout(function() {
                    form.submit();
                }, 1000);
            },
            saveProgress() {
                this.passBtnDisabled = true;
                this.skill_assessment_status = '';

                let form = this.$refs['form'];
                setTimeout(function() {
                    form.submit();
                }, 1000);
            },
            convertDate(date, format = 'YYYY-MM-DD HH:mm') {
                return moment.parseZone(date).format(format)
            },
        },
        mounted() {
            if (this.jobApplication.skill_assessment_status == 'passed') {
                this.passBtnDisabled = true;
            }
        },
        watch: {
            //watch jobApplication deep true
            jobApplication: {
                handler: function (newVal, oldVal) {
                    this.passBtnDisabled = false;
                    if (newVal.skill_assessment_status == 'passed') {
                        this.passBtnDisabled = true;
                    }
                },
                deep: true
            }
        },
        computed: {
            disabled() {
                return ( this.jobApplication.first_interview_status === null || this.jobApplication.first_interview_status === '') ? true : false
            }
        }
    }
</script>

    <template>
        <div class="language-proficiency">
            <form method="post" ref="form" enctype="multipart/form-data">
                <input type="hidden" name="_csrfToken" :value="csrfToken" />
                <input type="hidden" name="fail_reason" :value="fail_reason" />
                <input type="hidden" name="skill_assessment_status" :value="skill_assessment_status">

            <div v-for="(skillAssessment, i) in jobApplication.skill_assessment_results" class="bg-white rounded p-4 pb-0 pt-2" :key="skillAssessment.id">
                <div class="grid-x grid-padding-x mb-2">
                    <div class="cell small-7">
                        <div style="width: 90%">
                            <input type="hidden" :name="`skill_assessment_results[${skillAssessment.skill_assessment_spec.id}][id]`" :value="skillAssessment.id" />
                            <b>Assessment {{ i + 1 }}: </b>
                            <span>{{ skillAssessment.skill_assessment_spec.title }}</span>

                            <div class="form-control skill-assessment-item">
                                <div v-if="skillAssessment.file_path" class="bg-white p-3 mb-2 d-flex justify-content-between">
                                    <label class="fw-bold">Files Uploaded</label>
                                    <a target="_blank" style="text-decoration: none; color: #6ABC45" :href="`${skillAssessment.file_path_cdn}`">{{ sliceString(skillAssessment.file_path_cdn) }}</a>
                                </div>
                                <div class="bg-white p-3 mb-2 grid-x justify-content-between" v-if="!skill_assessment_status || skill_assessment_status.length === 0">
                                    <label class="fw-bold cell small-4">
                                        <span v-if="skillAssessment.file_path_cdn">Update uploaded File</span>
                                        <span v-else>Upload file</span>
                                    </label>
                                    <input class="cell small-8" type="file" :name="`skill_assessment_results[${skillAssessment.skill_assessment_spec.id}][file_path]`"/>
                                    <input
                                        type="hidden"
                                        :name="`skill_assessment_results[${skillAssessment.skill_assessment_spec.id}][skills_assessment_specs_id]`"
                                        :value="`${skillAssessment.skill_assessment_spec.id}`"
                                    />
                                </div>
                                <p>Recruiter Score:</p>
                                <div class="d-flex align-items-center gap-2">
                                    <input
                                        type="number"
                                        step="1"
                                        min="0"
                                        max="100"
                                        required
                                        :name="`skill_assessment_results[${skillAssessment.skill_assessment_spec.id}][score]`"
                                        v-model="skillAssessment.score"
                                        style="width: unset;"
                                        class="bg-white"
                                    />
                                    <span>%</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="cell small-5">
                        <div class="fw-bold"><small>Instructions:</small></div>
                        <span style="white-space: pre-line; font-size: .9rem" v-html="skillAssessment.skill_assessment_spec.instructions"></span>
                    </div>
                </div>
                <hr v-if="i < jobApplication.skill_assessment_results.length - 1">
            </div>

            <div v-if="jobApplication.skill_assessment_results.length === 0">
                <p class="mb-6">Candidate has not uploaded any audio clips</p>
                <div class="grid-x bg-white padding-10" v-for="(skillAssessmentSpec , i) in jobApplication.job.requisition.person_specification.skill_assessment_specs" :key="`skillAssesement${skillAssessmentSpec.id}`">
                    <div class="cell small-6">
                        <strong>Assessment {{ i + 1 }}:</strong>
                        <div class="grid-x grid-padding-x">
                            <div class="cell small-6">
                                {{ skillAssessmentSpec.title }}
                            </div>
                            <div class="cell small-6">
                                <input type="file" :name="`skill_assessment_results[${skillAssessmentSpec.id}][file_path]`"/>
                                <input
                                    type="hidden"
                                    :name="`skill_assessment_results[${skillAssessmentSpec.id}][skills_assessment_specs_id]`"
                                    :value="`${skillAssessmentSpec.id}`"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="cell small-5 ml-30">
                        <strong>Instructions:</strong>
                        <p class="mt-10" v-html="skillAssessmentSpec.instructions"></p>
                    </div>
                    <hr v-if="i < jobApplication.job.requisition.person_specification.skill_assessment_specs.length - 1">
                </div>
            </div>

            <div v-if="jobApplication.skill_assessment_results.length > 0 && (skill_assessment_status && skill_assessment_status.length > 0)" class="px-4">
                <hr style="max-width: unset;" />

                <template v-if="jobApplication.skill_assessment_status != null">
                    <strong>Final Status: </strong> <span class="">{{ jobApplication.skill_assessment_status }}</span>
                    <span v-if="logs !== null && logs !== ''">
                        &nbsp;(Updated By {{ logs.user.first_name }} {{ logs.user.last_name }} - {{ convertDate(logs.created) }})
                    </span>
                </template>

            </div>

            <div class="grid-x grid-padding-x px-4">
                <div class="cell shrink">
                    <button class="button px-5" type="button" @click="saveProgress()">Save Progress</button>
                </div>

                <div class="cell shrink">
                    <button class="button px-5" type="button" @click="disablePassBtn()" :disabled="passBtnDisabled || disabled">Pass</button>
                </div>

                <div>
                    <button class="d-none" value="failed" ref="failedButton" name="skill_assessment_status"></button>
                    <button :disabled="disabled" class="button alert px-5" type="button" @click="toggleModal('failModal')">Fail</button>
                </div>

                <div class="cell shrink">
                    <button :disabled="disabled" class="button recycle px-5" type="button" @click="toggleModal('recycleModal')">Recycle</button>
                </div>
            </div>
        </form>

        <recycle-modal ref="recycleModal" :job-application="jobApplication" :csrf-token="csrfToken" />
        <fail-modal ref="failModal" :job-application="jobApplication" @submit="fail" />
    </div>
</template>

<style lang="scss" scoped>
@import './assets/scss/frontend/base/colour_vars.scss';

    .skill-assessment-item {
        background-color: $off-white !important;
        padding: 20px !important;
        border-radius: 0;
        margin-top: 6px;
    }
</style>